import React, { Component } from "react";
// import Header from './Header.js';
// import Footer from './Footer';
import AboutNHPModal from "./AboutNHPModal";
/**
 * About NHP Page COntent
 */

export default class AboutNHP extends Component {
  render() {
    const details = {
      ims: {
        title: "Improving In Situ Monitoring System (IMS)",
        info:
          "To expand and upgrade water resources monitoring systems, bolster database population and maintenance, develop community-based data collection and water management, and conduct site specific surveys to the states in the Indus, Ganges and Brahmaputra Basins and in North-East India",
      },
      sis: {
        title: "Improving Spatial Information System (SIS)",
        info:
          "To strengthen and make available remote sensing and spatial information data to water managers and stakeholders through providing and processing of spatial data sets, creating tools for tailor-made processing of spatial data, and developing web-based portals for public access to information. Development of centralized spatial data sets will largely be produced by National Remotes Sensing Center (NRSC), Indian Meteorological Department (IMD) and Survey of India (SOI) with the dissemination of the information via a publicly accessible, web-based portal for non-classified data.",
      },
      wroma: {
        title:
          "Promoting Water Resources Operation and Management Applications (WROMA)",
        info:
          "To ensure the usefulness of the WRMS and WRIS data sets through decision support systems (DSS) for river basin planning, water balance assessments, climate risk assessments, water quality management, scenario analysis for investment planning, and tools for community based water management. It will develop short-term and seasonal flow forecasts, establish multiple flood/flow forecasting systems important for operation of reservoirs and flood management, and introduce on pilot basis operation and water distribution systems for irrigation systems.Flagship knowledge products will include IWRM systems for selected river basins, a report on the status of India’s water resources, including water balance assessments, water quality assessments and support purpose driven studies (PDS) on specific issues for each IA, including climate risk assessments for present and planned water resources infrastructure.",
      },
      wricb: {
        title:
          "Strengthening Water Resources Institutions and Capacity Building (WRICB)",
        info:
          "To strengthen and build capacity in the participating Implementing Agencies (Water Resources Institutions) through establishing Water Resources Knowledge Centers and providing infrastructure and communication equipment, capacity building and extensive training programs, supporting project management through Technical Assistance and Management Consultancies, and funding of incremental staff. In particular, the project will support the establishment of a National Water Information Center (upgraded version of India-WRIS) and centers of excellence at national and state levels.",
      },
    };

    return (
      <div>
        {/* <Header/> */}
        <div
          className="card"
          style={{
            padding: "15px",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            overflowY: "auto",
          }}
        >
          <div className="card-body">
            <h3 className="card-title" style={{ color: "#002171" }}>
              About National Hydrology Project
            </h3>
            <hr />

            <div className="card-text" style={{ textAlign: "justify" }}>
              National Hydrology Project (NHP) is being taken up from Ministry of Jal Shakti, Govt. of India with financial aid from World
              Bank. The objective of project is to improve the extent and
              accessibility of water resources information and strengthen
              institutional capacity to enable improved water resources planning
              and management across India. The mission is to establish an
              effective and sound hydrologic database and Hydrological
              Information System (HIS), together with the development of
              consistent and scientifically based tools and design aids to
              assist in the effective water resources planning and management
              within each to the implementing agencies based on sound scientific
              driven framework. HP-III will be implemented across India in all
              states and union territories.
            </div>
            <h5 className="card-title">
              The project comprises four broad components:
            </h5>
            <br />
            <AboutNHPModal title={details.ims.title} info={details.ims.info} />
            <br />
            <AboutNHPModal title={details.sis.title} info={details.sis.info} />
            <br />
            <AboutNHPModal
              title={details.wroma.title}
              info={details.wroma.info}
            />
            <br />
            <AboutNHPModal
              title={details.wricb.title}
              info={details.wricb.info}
            />
            <br />
            <p className="card-text" style={{ textAlign: "justify" }}>
              In this connection, Ministry of Water Resources, River Development
              & Ganga Rejuvenation (MoWR, RD&GR) consulted NRSC to support NHP
              through geo-spatial data products, services, customized
              applications development and capacity building to the
              stakeholders. NRSC participated various meetings organized by
              MoWR, RD&GR and World Bank and deliberated on the possible role
              NRSC/ISRO would play in NHP implementation. Comments and
              concurrence of draft EFC memo was communicated from the Office of
              Secretary of Dept. of Space to MoWR, RD&GR. NRSC participated in
              the Wrap-up Meeting of NHP World Bank Mission held during 14-15
              Sep, 2015 at New Delhi and presented the details of possible Role
              of National Remote Sensing Centre (ISRO) under National Hydrology
              Project. Further, Joint Secretary, MoWR, RD&GR communicated
              approval of EFC Memo through D.O. No. 21/97/2015-NHP/3925 Dt. 26th
              Nov, 2015. In response to the above, the present proposal is
              formulated, where in NRSC/ISRO is supporting NHP through
              geospatial data based services, water resources/hydrology
              applications development and capacity building under three NHP
              components – namely SIS, WROMA & WRICB.
            </p>

            <div className="card-text" style={{ textAlign: "justify" }}>
              National Hydrology Project has been approved by the cabinet on
              06.04.2016 as a central sector scheme with a total outlay of
              Rs.3679.7674 crore [Rs.3,640 crore for National Hydrology Project
              (NHP) and Rs.39.7674 crore for establishment of National Water
              informatics Centre (NWIC) as a repository of nation-wide water
              resources data]. NWIC is envisaged as an independent organization
              with adequate administrative and financial powers under the
              overall control of Secretary, MoWR, RD&GR.
              <h5 className="card-title">Project Objective</h5>
              To improve the extent, quality, and accessibility of water
              resources information,decision support system for floods and basin
              level resource assessment/planning and to strengthen the capacity
              of targeted water resources professionals and management
              institutions in India.
              <h5 className="card-title">Project Highlight</h5>
              <ul>
                <li>Central Sector Scheme, with 100% grant to the States</li>
                <li>
                  Budget Outlay: about Rs3,640 Crore, with World Bank Assistance
                  to the tune of 50% of the project cost
                </li>
                <li>Timeline: 8 years from 2016-17 to 2023-24</li>
                <li>Scale: Pan India</li>
                <li>Lead Agency: MoWR, RD&amp;GR</li>
                <li>
                  Implementing Agencies: 49 (including 10 from Central
                  Government and 39 from States)
                </li>
                <li>
                  Loan agreement with world bank has been signed on 18-4-2017.
                </li>
              </ul>
              <h5 className="card-title">Project Concept</h5>
              <ol type="1">
                <li>
                  <b>Modernizing Monitoring network</b>:The project will
                  establish&amp; strengthen monitoring networks in project
                  states, with a focus on deploying new sensors, data storage,
                  and telemetry technologies across the whole country, to
                  establish comprehensive, modern, automated, real-time
                  monitoring systems for surface water and ground water.
                </li>
                <li>
                  <b>Transforming Knowledge Access</b>:The project will build on
                  the dramatic advances in cloud computing, internet, mobile
                  devices, social media and other communication tools to
                  modernize access to and visualization of customized water
                  information by different stakeholders.
                </li>
                <li>
                  <b>Enhancing Analytical Tools</b>:The project will developand
                  demonstrate tools for water resources assessment, hydro logic
                  and flood inundation forecasting, water infrastructure
                  operations, ground water modeling, and river basin and
                  investment planning.
                </li>
                <li>
                  <b>Modernizing Institutions</b>:The project will complement
                  technology investments with investments in people and
                  institutional capacity. Support will be provided for
                  developing centers of expertise, innovative learning
                  approaches, collaboration with academia and research
                  institutes, and outreach programs. Office and equipment will
                  be modernized to streamline work flows to effectively leverage
                  the technology investments.
                </li>
              </ol>
              <h5 className="card-title">Project Components</h5>
              <ol type="A">
                <li>
                  <b>Water Resources Monitoring Systems:</b>This component will
                  finance the establishment/modernization of new and existing
                  hydro met monitoring systems including meteorology, stream
                  flow, ground water, water quality and water storage
                  measurements, and construction of hydro-informatics centers
                  that capture both water resources and uses. This component
                  will be implemented by states/UTs with the support of core
                  central agencies. The major activities will include
                  establishment of hydro met observation networks; establishment
                  of Supervisory Control and Data Acquisition (SCADA) systems
                  for water infrastructure; and establishment of
                  hydro-informatics centers. Water Resources Information
                  Systems:Component B will support the strengthening of national
                  and sub-national water information centres with web-enabled
                  WRISs through standardization of databases and products from
                  various data sources/departments and make comprehensive,
                  timely, and integrated water resources information available
                  to decision makers for effective planning, decision making,
                  and operations. The sources of data/information will include
                  the real-time data acquisition networks and centres under
                  Component A, remote sensing data, and topographical maps and
                  knowledge products developed under Component C. Emphasis will
                  be on improving quality of and access to water information and
                  on expanding public access beyond data to analytical results
                  (trends, water balance, and so on) as well as to contribute to
                  evidence based operational and investment plans. The project
                  will support development or strengthening of centres for
                  web-based WRIS at the central, regional, river basin, and
                  state/UT levels. Some of the key activities under this
                  component are: Strengthening of India Water Resources
                  Information System (WRIS); and Regional /State Water Resources
                  Information System.
                </li>
                <li>
                  <b>Water Resources Operations and Planning Systems</b>:This
                  component will support the development of interactive
                  analytical tools and decision support platform that would
                  integrate database, models and scenario manager for
                  hydrological flood forecasting, integrated reservoir
                  operations, and water resources accounting for improved
                  operation, planning, and management of both surface water and
                  ground water, based on basin approach. The component will
                  provide interactive systems to analyze the impacts of
                  alternative management scenarios and generate knowledge
                  products using real-time data under Component B. Component C
                  has three subcomponents: Development of analytical tools and
                  decision-support platform (river basin modeling, stream flow
                  forecasting and reservoir operation systems, and irrigation
                  design and operations); Purposedrivensupport; and Piloting
                  innovative knowledge products.
                </li>
                <li>
                  <b>Institutional Capacity Enhancement</b>: Component D aims to
                  build capacity for knowledge-based water resources management.
                  It will support subcomponents in the establishment of (i)
                  water resources knowledge centres, (ii) professional
                  development, (iii) project management, and (iv) operational
                  support. The project will develop partnerships with national
                  and international institutes, establish communities of
                  practice, internships and visiting expert programs, customized
                  training and workshops for knowledge exchange and professional
                  networking. Centers of Excellence (national as well as
                  regional) will also be established to address specific needs.
                  Outreach and awareness programmes will be an integral part of
                  the project and will showcase the NHP to a broad audience,
                  both for specific target audiences such as local communities
                  in irrigated or flood prone areas and for the public at large.
                  Beneficiaries
                </li>

                <li>
                  <b>The project has two groups of direct beneficiaries</b>:
                  central and state implementing agencies (IAs) responsible for
                  surface water and/or ground water planning and management,
                  including river basin organizations (RBOs) and users of the
                  WRIS across various sectors and around the world. The ultimate
                  beneficiaries will be the selected farm communities which
                  benefited from pilot projects for water management; rural and
                  urban water and power users; populations affected by floods
                  and droughts, especially poor rural people, and farm families
                  who may benefit from improved irrigation water supply and
                  management; stakeholders across the energy, inland waterways,
                  environment, and agriculture ministries; research and
                  educational institutions; students and researchers; and
                  non-governmental organizations, civil society organizations,
                  and the private sector.
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* <Footer/> */}
      </div>
    );
  }
}
